import { db } from './firebase';
import { collection, addDoc, getDocs } from 'firebase/firestore';

// Test Firestore connection
const testFirestore = async () => {
  console.log('🔍 Testing Firestore connection...');
  
  try {
    // Test write
    const testDoc = await addDoc(collection(db, 'test'), {
      message: 'Hello Firestore!',
      timestamp: new Date()
    });
    console.log('✅ Write successful:', testDoc.id);
    
    // Test read
    const querySnapshot = await getDocs(collection(db, 'test'));
    console.log('✅ Read successful, found', querySnapshot.size, 'documents');
    
    // Clean up
    querySnapshot.forEach(async (doc) => {
      await doc.ref.delete();
    });
    console.log('✅ Cleanup successful');
    
    return true;
  } catch (error) {
    console.error('❌ Firestore test failed:', error);
    
    if (error.code === 'permission-denied') {
      console.error('🔧 Fix: Update Firestore security rules in Firebase Console');
    } else if (error.code === 'unavailable') {
      console.error('🔧 Fix: Check internet connection');
    }
    
    return false;
  }
};

export default testFirestore;
